import { inject, Injectable } from '@angular/core';
import { OpsServicesDataDto } from '../types';
import { httpRetry } from '$core/helpers/http-retry';
import { Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { StaticStorage } from '../static-storage';

@Injectable({
  providedIn: 'root',
})
export class OpsServicesService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getOpsServicesStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/ops-services').pipe(
      httpRetry(5),
      tap((res: OpsServicesDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
